/** HubSpot "Apply now" lightweight email capture form (WEB-719). */
export const APPLY_NOW_HUBSPOT_FORM_GUID =
  "5f7944e6-dcb2-4e29-8a09-20ea9c7c6b60";
export const APPLY_NOW_HUBSPOT_PORTAL_ID = "6440909";
export const APPLY_NOW_FORM_NAME = "Apply now";

export const APPLY_NOW_SIGNUP_URL = "https://app.wayflyer.com/authn/signup";

/**
 * Auth0 hint forcing the signup screen. An `email` in the URL already carries
 * signup intent; without one the app falls through to the login screen, so an
 * email-less apply-now redirect has to say so explicitly.
 */
export const SIGNUP_SCREEN_HINT_PARAM = "screen_hint";
export const SIGNUP_SCREEN_HINT_VALUE = "signup";

/** Cookie keys read by the Wayflyer app signup flow. */
export const SIGNUP_PREFILL_COOKIE_KEYS = {
  revenue: "revenue",
  countryOfIncorporation: "country-of-incorporation",
} as const;
